import { useEffect, useState } from "react";
import { clipList, ensureVersion, preloadClips } from "../lib/audioStore";

const IDLE = { status: "idle", done: 0, total: 0, failed: 0 };

// Pre-downloads every clip at boot (and again whenever the server's audio_version changes); retries until all are stored.
export const useAudioCache = (game) => {
  const [state, setState] = useState(IDLE);
  const version = game?.audio_version;

  useEffect(() => {
    if (!game || !version) return undefined;
    let stop = false;
    let timer = null;
    navigator.storage?.persist?.().catch(() => {});
    const urls = clipList(game);
    const run = async (round) => {
      if (stop) return;
      setState({ status: "caching", done: 0, total: urls.length, failed: 0 });
      await ensureVersion(version);
      const r = await preloadClips(urls, {
        onProgress: (p) => { if (!stop) setState({ status: "caching", ...p }); },
        shouldStop: () => stop,
      });
      if (stop || r.stopped) return;
      if (r.failed.length) {
        setState({ status: "retry", done: r.done, total: urls.length, failed: r.failed.length });
        timer = setTimeout(() => run(round + 1), Math.min(60000, 10000 * (round + 1)));
      } else {
        setState({ status: "ready", done: urls.length, total: urls.length, failed: 0 });
      }
    };
    run(0);
    return () => { stop = true; clearTimeout(timer); };
  }, [version]); // eslint-disable-line react-hooks/exhaustive-deps

  return state;
};
